export function getBaseConfig(callback) {
  function mapper(array) {
    return array.map(ele => ({ label: ele.typeStr, value: ele.type }))
  }
  // 分类
  // 1歌手类型
  // 2地区
  // 3歌手身份
  // 4流派
  // 5.国籍
  // 6.电话区号
  window.$baseConf = {}
  if (window.$baseConf.type) {
    return callback && callback();
  }
  window.$req('getBaseConfig', { category: [1, 2, 3, 4, 5].join(',') }).then(res => {
    let data = res.data
    let conf = {
      'type': mapper(data[1]),
      'area': mapper(data[2]),
      'identity': mapper(data[3]),
      'genre': mapper(data[4]),
      'country': mapper(data[5]),
    }
    Object.assign(window.$baseConf, conf)
    callback && callback()
  })
}